var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyNameIconV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.726,
    height: 25.241,
    viewBox: "0 0 28.726 25.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31904",
    "data-name": "Rectangle 31904",
    width: 28.726,
    height: 25.241,
    fill: "#3c3c3b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14152",
    "data-name": "Group 14152",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14151",
    "data-name": "Group 14151",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40606",
    "data-name": "Path 40606",
    d: "M19.61,9.316H15.741V10.8h2.383A7.255,7.255,0,0,1,19.61,9.316",
    transform: "translate(-3.144 -1.861)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40607",
    "data-name": "Path 40607",
    d: "M17.438,18.766a7.151,7.151,0,0,1,.363-7.015l-2.06,0v8.224a7.233,7.233,0,0,1,1.7-1.207",
    transform: "translate(-3.144 -2.346)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40608",
    "data-name": "Path 40608",
    d: "M12.079,18.167V0H0V19.958H10.951a7.2,7.2,0,0,1,1.128-1.791M5.02,14.825h-2.7v-2.7h2.7Zm0-4.642h-2.7v-2.7h2.7Zm0-4.642h-2.7V2.84h2.7ZM9.683,14.83h-2.7v-2.7h2.7Zm0-4.642h-2.7v-2.7h2.7ZM6.986,2.84h2.7V5.547h-2.7Z",
    transform: "translate(0 0)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40609",
    "data-name": "Path 40609",
    d: "M28.584,14.022A4.153,4.153,0,1,1,24.43,9.869a4.154,4.154,0,0,1,4.153,4.153",
    transform: "translate(-4.05 -1.971)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40610",
    "data-name": "Path 40610",
    d: "M26.3,20.944a4.954,4.954,0,0,1-5.835,0A10.336,10.336,0,0,0,15.11,27.65c-.25.86.257,1.773.974,1.773H30.691c.718,0,1.226-.914.974-1.773a10.332,10.332,0,0,0-5.359-6.706",
    transform: "translate(-3.005 -4.183)",
    fill: "#3c3c3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyNameIconV2);
export default __webpack_public_path__ + "static/media/Company Name Icon V2.ce01d511e961c1812e38b91d6b69879c.svg";
export { ForwardRef as ReactComponent };